import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Query, Mutation } from 'react-apollo';
import { toast } from 'react-toastify';
import Loading from '../Loading';
import BlankState from '../BlankState';
import handleToastError from '../../helpers/handleToastError';
import SchoolApplicationSettingsForm from '../SchoolApplicationSettingsForm';

const SchoolApplicationSettings = ({ query, mutation }) => {
  const { definitions } = query;
  const [firstDefinition] = definitions;
  const { name: { value } } = firstDefinition;

  return (
    <Fragment>
      <Query query={query}>
        {({ loading, data, error }) => {
          if (loading) {
            return <Loading />;
          }

          if (error) {
            return <BlankState title="Error" subtitle="There was an error loading" />;
          }

          return (
            <Fragment>
              <h2>Application Settings</h2>
              <div className="last-edit">{`Last Edited: ${data[value].lastEdited}`}</div>
              <div className="text-block-14">Manage application waitlist.</div>
              <div className="top-border">
                <div className="w-form">
                  <Mutation
                    mutation={mutation}
                    onError={mutationError => handleToastError(mutationError)}
                    onCompleted={() => toast('Update Successful')}
                  >
                    {(mutationFunc) => {
                      const update = values => (
                        mutationFunc({
                          variables: {
                            input: {
                              ...values,
                            },
                          },
                        })
                      );

                      return (
                        <SchoolApplicationSettingsForm
                          {...data[value]}
                          onSubmit={update}
                        />
                      );
                    }}
                  </Mutation>
                </div>
              </div>
            </Fragment>
          );
        }}
      </Query>
    </Fragment>
  );
};

SchoolApplicationSettings.propTypes = {
  query: PropTypes.object.isRequired,
  mutation: PropTypes.object.isRequired,
};

export default SchoolApplicationSettings;
